<div class="sx-login">
  <app-spinner></app-spinner>
  <p>
    {{'core.loading-report.info-text' | translate}}
  </p>
  <div class="sxl-align-right">
    <button *ngIf="canClose" mat-button class="sx-button"
      (click)="closeSelf()">{{'core.loading-report.close-page' | translate}}</button>
  </div>
</div>